var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title",class:{[_vm.fontSize]:true}},[_c('span',{staticClass:"tag"}),_vm._v(" "+_vm._s(_vm.name)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }